// BOTÓN DE CERRAR ANUNCIO: K-UX 
(function () {
  const keyFor = (id) => 'announcement_closed_' + id;

  function hideWrapperByBar(bar) {
    const wrapper = bar.parentElement;
    if (wrapper) {
      wrapper.style.display = 'none';
      wrapper.setAttribute('aria-hidden', 'true');
    } else {
      bar.style.display = 'none';
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function onClose(bar) {
    const sectionId = bar.getAttribute('data-announcement-id');

    try {
      const sliderEl = bar.querySelector('announcement-bar-slider');
      if (sliderEl && sliderEl.slider && typeof sliderEl.slider.destroy === 'function') {
        sliderEl.slider.destroy(true, true);
      }
    } catch (e) {
   
    }

    hideWrapperByBar(bar);

    if (sectionId) {
      try {
        sessionStorage.setItem(keyFor(sectionId), '1');

      } catch (e) {}
    }
  }

  function initOnce() {
    document.querySelectorAll('.js-announcement-bar[data-announcement-id]').forEach((bar) => {
      const sectionId = bar.getAttribute('data-announcement-id');
      if (!sectionId) return;
      try {
        if (sessionStorage.getItem(keyFor(sectionId))) {
          const wrapper = bar.parentElement;
          if (wrapper) wrapper.style.display = 'none';
          else bar.style.display = 'none';
        }
      } catch (e) {}
    });
  }

  function setupDelegation() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.announcement-bar__close') : null;
      if (!btn) return;
      var bar = btn.closest('.js-announcement-bar');
      if (!bar) return;
      onClose(bar);
    });
  }

  function init() {
    initOnce();
    setupDelegation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else init();

  document.addEventListener('shopify:section:load', function () {
    initOnce();
  });
})();